class EventDates
{
    constructor()
    {
        var self = this;
        
        this.oneDay = 60 * 60 * 24 * 1000; // a day in miliseconds

        this.dateInterval = 0; // end date on same day
        this.timeInterval = 60; // 60 minutes between events

        this.start_date = $("#sb-events-start-date");
        this.start_time = $("#sb-events-start-date-time");
        this.end_time = $("#sb-events-end-date-time");
        this.end_date = $("#sb-events-end-date");
        this.all_day = $("#sb-events-all-day");

        this.start_list = new EventTimeList(this.start_time, true);
        this.end_list = new EventTimeList(this.end_time, false);

        this.initStartDate();
        this.initEndDate();
    }
    
    initStartDate()
    {
        var self = this;
        for (var i = 0; i < 48; i++) {
            var date = new Date(2017, 1, 1, 0, 0);
            date.setMinutes(i * 30);
    
            var hours = date.getHours();
            var id = 'evt-start-date-' + date.getHours() + '-' + date.getMinutes();
            
            var value = DateFormat.formatTime(date);
            var html = '<li id="' + id + '" data-value="'+ value  +'">' +  value + "</li>";

            this.start_list.timeUl.append(html);
        }
       
    /*
        if (this.start_time.val() == '') { 
            this.start_time.val(DateFormat.formatTime(now));   
        }

        if (this.start_date.val() == '') {
            this.start_date.val(DateFormat.formatDate(now));
        }
    */

        this.start_list.timeUl
        .on("click", "li", function()
        {
            var initial_value = self.start_time.val();
            self.start_time.val($(this).data('value'));       
         //   self.start_time.focus();

            if (initial_value != self.start_time.val()) {
                self.start_time.trigger('change');
            }
        });

        this.start_time
        .on('focus', function()
        {
            // selct date to focus to. 
            var date = self.getStartDate();
            
            if (!date) {
                date = new Date();
            }
     
            if (date.getHours() < 2) {
                date.setHours(0);
            }
            date.setMinutes(-30);
            
            var id = 'evt-start-date-' + date.getHours() + '-' + date.getMinutes();

            var li = $("#" + id);

            self.start_list.timeUl.scrollTop(0);
            self.start_list.timeUl.scrollTop(li.position().top);
        });

        this.start_date
        .on('change', function()
        {
            if (self.dateInterval) {
                var start = self.getStartDate();
                start.setDate(start.getDate() + self.dateInterval);
                self.end_date.val(DateFormat.formatDate(start));
            } else {
                self.end_date.val(self.start_date.val());
            }
        });

        this.start_time
        .on('change', function()
        {
            var start = self.getStartDate(new Date());

            if (self.timeInterval) {
                start.setMinutes(start.getMinutes() + self.timeInterval);
            }
        /*
            var time = start.getTime();
            time += self.timeInterval * 1000;
            start.setTime(time);
        */
            
            self.end_time.val(DateFormat.formatTime(start));
 
            self.refreshEndList();
        });

    }

    getDateInterval()
    {
        var start_date; 
        
        if (!(start_date = this.getStartDate())) {
            return 0;        
        }

        start_date.setMinutes(0);
        start_date.setHours(0);
          
        var end_date = this.getEndDate();
        end_date.setMinutes(0);
        end_date.setHours(0);
        
        var start = start_date.getTime();
        var end = end_date.getTime();
        
        return (end - start) / this.oneDay;
    }

    getTimeInterval()
    {
        var start_date;
        
        if (!(start_date = this.getStartDate())) {
            return 60;
        }

        start_date.setYear(2017);
        start_date.setMonth(1);
        start_date.setDate(1);
          
        var end_date = this.getEndDate();
        end_date.setYear(2017);
        end_date.setMonth(1);
        end_date.setDate(1);
        
        var start = start_date.getTime();
        var end = end_date.getTime();
        
        var retval =  (end - start) / 60 / 1000;

        if (retval < 0) {
            retval = (24 * 60) + retval;
        }

        return retval;
    }


    getStartDate()
    {
        var value = this.start_time.val();
        var date;
        var ofset;
        var offset;
            
        if (this.start_date.val().length === 0) {
            return;
        }

        if (value.length && (date = DateFormat.parseDate(this.start_date.val(), value))) {
        } else {
            date = DateFormat.parseDate(this.start_date.val());
            var minutes = date.getMinutes();
            if (minutes <= 30) {
                offset = 30 - minutes;
            } else {
                offset = 60 - minutes;
            }
            date.setMinutes(offset + minutes);
        }

        return date;
    }

    getEndDate()
    {
        var start_str = this.start_time.val();
        var end_str = this.end_time.val();
        var date;

        if (end_str) {
            date =  DateFormat.parseDate(this.end_date.val() || this.start_date.val(), end_str);
        } else {
            if (!(date = this.getStartDate())) {
                return;
            }
            date.setMinutes(this.timeInterval);
        }

        return date;
    }

    initEndDate()
    {
        var self = this;
        var now = this.getEndDate(new Date());

        var dateInterval;
        if ((dateInterval = this.getDateInterval()) >= 0) {
            this.dateInterval = dateInterval;
        }

        var timeINterval;
        this.timeInterval = this.getTimeInterval();
        
    
    /*
        if (this.end_time.val() == '') { 
            this.end_time.val(DateFormat.formatTime(now));   
        }

        if (this.end_date.val() == '') {
            this.end_date.val(DateFormat.formatDate(now));
        }
    */

        self.end_date
        .on('change', function()
        {
            var dateInterval;
            if ((dateInterval = self.getDateInterval()) >= 0) {
                self.dateInterval = dateInterval;
            }
        });

        this.end_time
        .on('focus', function()
        {
            // selct date to focus to. 
            var date;
            
            if (!(date = self.getEndDate())) {
                return;
            }
            date.setMinutes(-30);
            
            var id = 'event-end-date-' + date.getHours() + '-' + date.getMinutes();

            var li = $("#" + id);
            
            if (li.length === 0) {
                return;
            }

            self.end_list.timeUl.scrollTop(0);
            self.end_list.timeUl.scrollTop(li.position().top);
        })
        .on('change', function()
        {
            // checkif we need to set the end date into the future

            if (self.end_date.val() != self.start_date.val()) {
                return;
            }

            var start_time = self.start_time.val();
            var end_time = self.end_time.val();

            if (!start_time || !end_time) {
              return;            
            }

            var start_date = DateFormat.parseDate(null, start_time);
            var end_date = DateFormat.parseDate(null, end_time);

            var start = start_date.getTime();
            var end = end_date.getTime();

            if (end < start) {
                start_date.setDate(start_date.getDate() + 1); 
                self.end_date.val(DateFormat.formatDate(start_date));
                self.end_date.trigger('change');
            }

            self.timeInterval = self.getTimeInterval();
        });

        this.refreshEndList();

        this.end_list.timeUl
        .on("click", "li", function()
        {
            var initial_value = self.end_time.val();
            self.end_time.val($(this).data('value'));       
            //self.end_time.focus();

            if (initial_value != self.end_time.val()) {
                self.end_time.trigger('change');
            }

        });

        var toggleAllDay = function()
        {
            if (self.all_day.prop('checked') === false) {
                self.end_time.add(self.start_time)
                .attr('required', 'required')
                .closest(".event-time-list-field")
                .css('display', '')
                ;
            } else {
                self.end_time.add(self.start_time)
                .removeAttr('required')
                .closest(".event-time-list-field")
                .css('display', 'none');
            }
        };

        this.all_day.on('change', toggleAllDay);
        toggleAllDay();
    }

    refreshEndList()
    {
        this.end_list.timeUl.empty();

        var self = this;
        var date;
        
        if (!(date = this.getStartDate())) {
            return;
        }
        var time = date.getTime();
        var diffDate = new Date(date.getTime());

        for (var i = 1; i < 48; i++) {
            diffDate.setMinutes(diffDate.getMinutes() + 30);

            var time_diff = diffDate.getTime() - date.getTime();
            var hours = Math.floor((time_diff % 86400000) / 3600000);
            var minutes = Math.floor(((time_diff % 86400000) % 3600000) / 60000);

            var value = DateFormat.formatTime(diffDate);

            var str = value + ' (';
            
            if (hours > 0) {
                str += hours;
            } else if (minutes === 0) {
                str += 0;
            }
            
            if (hours > 0 && minutes) {
                str += '.';
            }
    
            str += minutes ? '5' : '';
            str += ' ';
            
            if (hours === 0) {
                str += 'Mins';
            } else if (hours === 1 && minutes === 0) {
                str += 'Hr';
            } else {
                str += 'Hrs';
            }
            str += ')';
     
            var id = 'event-end-date-' + diffDate.getHours() + '-' + diffDate.getMinutes();
     
            var li = '<li id="' + id + '" data-value="'+ value  +'">' +  str + "</li>";
            this.end_list.timeUl.append(li);
        }
    }


}

class EventTimeList
{
    constructor(input, is_start)
    {
        var self = this;

        this.is_start = is_start;
        this.input = input;
        this.cont = input.closest(".event-time-list");
        this.timeMenu = this.cont.find(".event-time-list-select");
        this.timeUl = this.cont.find(".event-time-list-select ul");

        this.input
        .on('focus', function()
        {
            // End list not currently populated if start time is not set
            if (self.timeMenu.find('li').length === 0) {
                return;
            }
            
            var pos = self.input.position();

            self.timeMenu.css({
                left: pos.left,
                top: pos.top + self.input.outerHeight(),
            });

            self.timeMenu.fadeIn();   
        })
        .on('blur', function()
        {
            var value = self.input.val();

            value = value.toLowerCase();

            self.input.val(value);
            
            
            self.timeMenu.fadeOut();   
        });


    }
}
